import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useScrollPosition } from 'utils/hooks';
import request from 'utils/request';

import { InputBase } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Catalogo from 'components/catalogo';
import CategoriesMenu from 'components/categoriesMenu';
import { accesorios as categories } from 'utils/data';

import {
  useStyles,
  SearchTitle,
  SearchInput,
  CategoriesContainer,
} from '../styles';

function CatalogoAccesorios({ setShowCarousel, hideSearchbar }) {
  const [searchValue, setSearchValue] = useState('');
  const classes = useStyles();
  const [fixedCategories, setFixedCategories] = useState(false);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const [shouldLoadMoreItems, setShouldLoadMoreItems] = useState(false);
  const categoriesRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    request(`https://api.bigbenespana.es/api/totem/products`, {
      queryParams: {
        filter: {
          'menus.Id': 1,
          'productos.estado': 1,
          ...(categoryId
            ? { 'productos_padre.id_categoria': categoryId }
            : null),
        },
        ...(searchValue.trim().length > 0
          ? { search: searchValue.trim() }
          : null),
        skip: 0,
        limit: 30,
      },
    })
      .then(data => {
        setProducts(data);
        setShouldLoadMoreItems(data.length > 0);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  }, [categoryId, searchValue]);

  const loadMoreProducts = skip => {
    setLoading(true);
    request(`https://api.bigbenespana.es/api/totem/products`, {
      queryParams: {
        filter: {
          'menus.Id': 1,
          'productos.estado': 1,
          ...(categoryId
            ? { 'productos_padre.id_categoria': categoryId }
            : null),
        },
        ...(searchValue.trim().length > 0
          ? { search: searchValue.trim() }
          : null),
        skip,
        limit: 30,
      },
    })
      .then(data => {
        setProducts(prevState => [...prevState, ...data]);
        setShouldLoadMoreItems(data.length > 0);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  useScrollPosition(
    ({ _, currPos }) => {
      if (currPos.y <= 46) {
        setFixedCategories(true);
      }
      if (currPos.y > 46) {
        setFixedCategories(false);
      }
    },
    [],
    categoriesRef,
  );

  return (
    <div>
      {!hideSearchbar && (
      <div className="container">
        <div className="text-center">
          <SearchTitle>Encuentra los accesorios que buscas.</SearchTitle>
          <SearchInput>
            <SearchIcon
              fontSize="large"
              style={{ marginRight: 8, color: '#bbb' }}
            />
            <InputBase
              inputRef={searchInputRef}
              type="search"
              placeholder="Buscar accesorios"
              className={classes.input}
              value={searchValue}
              onChange={({ target }) => {
                setShowCarousel(
                  target.value === '' &&
                    document.activeElement !== searchInputRef.current,
                );
                setSearchValue(target.value);
              }}
              onKeyUp={({ target }) => {
                setShowCarousel(
                  target.value === '' &&
                    document.activeElement !== searchInputRef.current,
                );
                setSearchValue(target.value);
              }}
              onFocus={() => {
                setShowCarousel(false);
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
              }}
              onBlur={() => {
                if (searchValue === '') {
                  setShowCarousel(true);
                }
              }}
              fullWidth
            />
          </SearchInput>
        </div>
      </div>
      )}
      <div ref={categoriesRef} className="position-relative">
        <div style={{ paddingBottom: 135 }} />
        <CategoriesContainer
          fixed={fixedCategories}
          className={fixedCategories ? 'container-fluid' : 'container'}
        >
          <div className="text-center">
            <CategoriesMenu
              items={categories}
              fixed={fixedCategories}
              selectedCategory={categoryId}
              onChange={id => {
                if (categoryId !== id) {
                  setProducts([]);
                  setCategoryId(id);
                }
              }}
            />
          </div>
        </CategoriesContainer>
      </div>
      <div className="container mb-5">
        <Catalogo
          loading={loading}
          products={products}
          loadMoreItems={loadMoreProducts}
          shouldLoadMoreItems={shouldLoadMoreItems}
        />
      </div>
    </div>
  );
}

CatalogoAccesorios.propTypes = {
  setShowCarousel: PropTypes.func.isRequired,
  hideSearchbar: PropTypes.bool,
};

export default CatalogoAccesorios;
